

















































































import { Vue, Component } from "vue-property-decorator";
import { ActionSheet, Cell } from "vant";

import trainPolicy from "@/service/trainPolicyService"; //getProductInfo
import train from "@/service/trainService";
import { forEach, times } from "lodash";
import * as _ from "lodash";
import dataShare from "../dataShare";
import moment from "moment";
@Component({
  components: {
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
  },
})
export default class extends Vue {
  //data
  dataShare = dataShare;
  productData: any = {};
  consumerResult: any[] = [];
  reasonShow = false;
  actions = [
    { CategoryID: 1517, name: this.$root.$t("mall_train_trainchangeinfos_woyaogaibianhangchengbuxiangfeiliao") as string, CategoryCode: "FlightChange", className: "itemClass" },
    { CategoryID: 1518, name: this.$root.$t("mall_train_trainchangeinfos_jicuohangchengriqishijianxingming") as string, CategoryCode: "FlightMistaken", className: "itemClass" },
    { CategoryID: 1519, name: this.$root.$t("mall_train_trainchangeinfos_hangbanyanwuhuoquxiao") as string, CategoryCode: "FlightDelay" },
  ];
  reasonVal = this.$root.$t("mall_train_trainchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin") as string;
  isCheckInDate = false;
  DepartDate: Date = new Date();
  ArriveDate: Date = new Date();

  get ProductId(): string {
    return (this as any).$route.query.ProductId;
  }
  get UniqueID(): string {
    return (this as any).$route.query.UniqueID;
  }
  get ServiceCode(): string {
    return (this as any).$route.query.ServiceCode;
  }
  get RuleType(): string {
    return (this as any).$route.query.RuleType;
  }
  get changeSource() {
    return dataShare.changeSource;
  }
  get ConsumerData() {
    return JSON.parse((this as any).$route.query.Consumers);
  }
  //mounted
  mounted() {
    this.getProductInfo();
  }
  // methods
  getProductInfo() {
    const data = {
      ProductID: this.ProductId,
    };
    trainPolicy.getProductInfo(data).then(res => {
      if (res.isSucc) {
        this.productData = res.result;
      }
    });
  }
  totalPrice() {
    let price: number = 0;
    _.forEach(this.productData, item => {
      _.forEach(item.Goods, el => {
        _.forEach(el.Prices, o => {
          price += o.SalesPrice;
        });
      });
    });
    return price;
  }
  submitReview() {
    const query = this.$route.query;

    const ProductID = this.ProductId + "-" + dataShare.changeSource[0].ProductID;

    const data: any = {
      BookingType: query.BookingType,
      ProductID: ProductID,
      UniqueID: query.UniqueID,
      // ReasonType: query.ReasonType + "",
      ReasonType: "1517",
      ReasonDetail: "",
      Consumers: this.ConsumerData,
      CreateMode: 1405,
      // ChangeID: this.ChangeID,
      ShoppingID: "",
    };
    if (query.seatType != undefined) {
      data.seat_type = query.seatType;
    }
    if (query.ShoppingID) {
      data.ShoppingID = query.ShoppingID;
    }
    train.OrderChange(data).then((res: any) => {
      if (res.isSucc) {
        this.$root.$toast(this.$root.$t("mall_train_trainchangeinfos_gaiqianchenggongqingninguanzhudingdanzhuangtai") as string);
        this.$router.push("/order/myOrder");
      } else {
        this.$root.$toast(this.$root.$t("mall_train_trainchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie") as string);
      }
    });
  }
  selectChangDate() {
    this.isCheckInDate = true;
  }
  formatDate(value: Date, format: string = "HH:mm") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  duration(value: number) {
    let x = moment.duration(value);
    return x.hours() + "h" + x.minutes() + "m";
  }
  back(): void {
    history.back();
  }
}
